import React from "react";
import "./styles.less";

export const NoticeWrap = (props) => {
  const { noticeList } = props;
  return (
    <div className="demo-list">
      <div className="rowup">
        {noticeList.map((notice, idx) => {
          return (
            <div className="noticeRow" key={`notice-item-${idx}`}>
              {notice}
            </div>
          );
        })}
      </div>
    </div>
  );
};
